import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { DEFAULT_DISTANCE_FROM_CONTAINER } from "../constants";
import { adjustLaterallyIfNeeded, adjustVerticallyIfNeeded, defaultPositionAdjustmentIfOverflowsVertically, getIdealBoundingRect, getIdealPositon, isLateralPositionAndOverflowing } from "./utils";
export var getIdealPosition = function getIdealPosition(position) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_DISTANCE_FROM_CONTAINER;
  var idealPosition = {
    newPosition: position
  };
  var idealPositionWithOffset = getIdealPositon(offset);
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (position === 'bottom') return _objectSpread(_objectSpread({}, idealPosition), {}, {
    top: idealPositionWithOffset
  });

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (position === 'top') return _objectSpread(_objectSpread({}, idealPosition), {}, {
    bottom: idealPositionWithOffset
  });

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (position === 'left') return _objectSpread(_objectSpread({}, idealPosition), {}, {
    right: idealPositionWithOffset
  });

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (position === 'right') return _objectSpread(_objectSpread({}, idealPosition), {}, {
    left: idealPositionWithOffset
  });
  return idealPosition;
};
var _adjustPosition = function adjustPosition(_ref) {
  var content = _ref.content,
    container = _ref.container,
    position = _ref.position,
    offset = _ref.offset;
  var idealRect = getIdealBoundingRect({
    container: container,
    content: content,
    position: position
  });

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (isLateralPositionAndOverflowing(position, idealRect)) return _adjustPosition({
    content: content,
    container: container,
    position: 'top'
  });
  var idealPosition = getIdealPosition(position, offset);

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (position === 'top' || position === 'bottom') return _objectSpread(_objectSpread(_objectSpread({}, idealPosition), adjustLaterallyIfNeeded(idealRect)), defaultPositionAdjustmentIfOverflowsVertically(idealRect, offset));
  return _objectSpread(_objectSpread({}, idealPosition), adjustVerticallyIfNeeded(idealRect));
};
export { _adjustPosition as adjustPosition };